import axios from "axios";

export default {
    namespaced: true,
    state: {
        loading: false,
        dokobitSessionCode: null,
    },
    mutations: {
        setDokobitSessionCode(state, val) {
            state.dokobitSessionCode = val;
        },
        setLoading(state, val) {
            state.loading = val;
        },
    },
    actions: {
        async getIdToken({commit}) {
            let success = false;
            try {
                const response = await axios.get(`${process.env.VUE_APP_AS_API_URL}/app/dokobit-id/`);
                const data = response.data;
                if (data.success === 1) {
                    commit("setDokobitSessionCode", response?.data?.token);
                    success = true;
                }
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
                commit("setRequestError", true, {root: true});
                commit("setErrorMessage", "Failed", {root: true});
            }
            return success;
        },
    }
}